import { Component, OnInit, OnDestroy } from "@angular/core";
import { BaseFilterController } from "../BaseFilterController";
import { FormBuilder, Validators } from '@angular/forms';
import {DictionaryService, TableService, ValidatorService} from "@amlCore/services";
import { Unsubscribable } from 'rxjs';
import { IDictItemType } from "../../interfaces";
import { ClientTypeEnum } from "@amlCore/enums";
import { ActivatedRoute } from "@angular/router";
import {ConsolidatedFilter} from "../../models/consolidatedFilter.model";

@Component({
  selector: "app-consolidated-info-filter",
  templateUrl: "./consolidatedInfoFilter.component.html"
})

export class ConsolidatedInfoFilterComponent extends BaseFilterController implements OnInit, OnDestroy {

  public selectObj = {
    typeSubjectList: [] as IDictItemType[]
  };

  placeholder = 'Поиск по ФИО, наименованию';

  public filterObjectModel = new ConsolidatedFilter();
  private subjectTypeUnsubscrible: Unsubscribable;

  constructor(private fb: FormBuilder,
              protected tableSrv: TableService,
              private dictSrv: DictionaryService,
              protected activatedRoute: ActivatedRoute,
              protected validationSrv: ValidatorService) {
    super(tableSrv, activatedRoute);
  }

  ngOnInit() {
    this.init();
    this.dictSrv.loadTypeClient().then(result => {
      this.selectObj.typeSubjectList = result.filter((item) =>
          [ClientTypeEnum.LEGAL_ENTITY, ClientTypeEnum.INDIVIDUAL_PERSON].includes(item.code));
    });
    this.subjectTypeUnsubscrible = this.formModel.get("subjectType").valueChanges.subscribe((typeCode) => {
      this.selectedClientType({ type: (typeCode || '') });
    });
  }

  public selectedClientType(data) {
    if (data.type === '') {
      return;
    }
    const currentSubjectTypeCode: string = data.type;
    const subjectTypeMap = {
      1: ["name"], // ClientTypeEnum.LEGAL_ENTITY
      2: ["name", "birthDate", "number", 'idSubject'], // ClientTypeEnum.INDIVIDUAL_PERSON
    };
    const [disableSubjectTypeCode] = Object.keys(subjectTypeMap).filter((typeCode) => typeCode !== currentSubjectTypeCode);

    subjectTypeMap[disableSubjectTypeCode].forEach((field: string) => {
      this.formModel.get(field).disable();
    });
    subjectTypeMap[currentSubjectTypeCode].forEach((field: string) => {
      this.formModel.get(field).enable();
    });
  }

  /**
   * Метод создания формы
   * @return FormGroup
   */
  public createFormModel() {
    const formConfig =  new ConsolidatedFilter();
    formConfig.birthDate = [null, this.validationSrv.getValidation({
      isDate: true
    })];
    return this.fb.group(formConfig);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.subjectTypeUnsubscrible.unsubscribe();
  }

  getStartFilterModel(): any {
    return {
      subjectType: ClientTypeEnum.LEGAL_ENTITY // тип субъекта
    } as ConsolidatedFilter;
  }

  /**
   * Описания полей
   */
  public getFilterDescription(): any {
    return {
      subjectType: 'Тип субъекта',
      name: 'Наименование',
      birthDate: 'Дата рождения',
      number: 'Номер документа',
      idSubject: 'Идентификатор'
    };
  }
}
